import * as v from "valibot";

// request
export const RequestSchema = v.object({
  Action: v.nullish(v.string()),
  Debug: v.nullish(v.string()),
  ClusterId: v.nullish(v.string()),
  IsCommon: v.nullish(v.boolean()),
  IsIncludesCni: v.nullish(v.boolean()),
  K8sVersion: v.string(),
  Name: v.nullish(v.string()),
  Type: v.nullish(v.string()),
  Version: v.nullish(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const AddonListSchema = v.object({
  AddonId: v.nullish(v.string()),
  AddonVersion: v.nullish(v.string()),
  Category: v.nullish(v.string()),
  DefaultInstall: v.boolean(),
  DependIamRole: v.nullish(v.string()),
  Description: v.nullish(v.string()),
  DescriptionCn: v.nullish(v.string()),
  MultiDeploy: v.boolean(),
  Name: v.nullish(v.string()),
  SubCategory: v.nullish(v.string()),
  SupportK8SVersion: v.nullish(v.array(v.string())),

  CustomParam: v.nullable(v.record(v.string(), v.string())),
  DefaultParam: v.nullish(v.record(v.string(), v.string())),
  IsHide: v.boolean(),
  Type: v.string(),
});
export type AddonList = v.InferOutput<typeof AddonListSchema>;

export const DataSchema = v.object({
  AddonList: v.nullish(v.array(AddonListSchema)),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
});
export type Response = v.InferOutput<typeof ResponseSchema>;
